export const GET_LIST_MOVIE_DROPDOWNS = "GET_LIST_MOVIE_DROPDOWNS"
export const GET_CINEMA_DROPDOWNS = "GET_CINEMA_DROPDOWNS"
export const GET_DATE_DROPDOWNS = "GET_DATE_DROPDOWNS"